import { render, staticRenderFns } from "./MotorBikeLeftDamage.vue?vue&type=template&id=488b62bc"
import script from "./MotorBikeLeftDamage.vue?vue&type=script&lang=js"
export * from "./MotorBikeLeftDamage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports